// 324 px: bisherige feste Breite des Panels (w-81)
export const PANEL_MIN_WIDTH = 324;
export const PANEL_MAX_WIDTH = 640;
export const PANEL_DEFAULT_WIDTH = PANEL_MIN_WIDTH;

// Begrenzt die Breite auf Min, Max und höchstens die Hälfte des Fensters
export function clampPanelWidth(width: number, viewportWidth: number): number {
  const max = Math.max(
    PANEL_MIN_WIDTH,
    Math.min(PANEL_MAX_WIDTH, Math.floor(viewportWidth / 2)),
  );
  return Math.round(Math.min(Math.max(width, PANEL_MIN_WIDTH), max));
}
